module.exports = __webpack_public_path__ + "1cedb6e919bfed6a2c1ec00b5d8ee620.svg";